import type { DefaultItem } from '@consta/uikit/Breadcrumbs'
import { Breadcrumbs } from '@consta/uikit/Breadcrumbs'
import {
  searchFromDbSources,
  selectActiveProjectId,
  selectSearchQuery,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { ImportDBResultViewMode } from '@core/core/types'
import { isCanImportFrom } from '@core/core/types'
import { Match, Show, Switch } from '@library/components'
import type { FC } from 'react'
import { useState } from 'react'

import { NewImportResults } from './NewImportResults'
import { NewImportSourceSelector } from './NewImportSourceSelectors'
import css from './OverallImport.css'
import type { OverallImportProps } from './types'

const pages: DefaultItem[] = [{ label: 'Новый импорт' }, { label: 'Поиск' }]

export const OverallImport: FC<OverallImportProps> = ({
  getFilesFromExplorer,
  addCrmsFiles,
  addGeoDFiles,
}) => {
  const [activeBreadItem, setActiveBreadItem] = useState(pages[0])
  const activeQuery = useAppSelector(selectSearchQuery)
  const dispatch = useAppDispatch()
  const projectId = useAppSelector(selectActiveProjectId)

  const selectedMode = activeQuery.mode
  const globalSearch = activeQuery.globalSearch ?? ''
  const onApplyGlobalSearch = (mode: ImportDBResultViewMode, globalSearch: string) => {
    const data = {
      query: { mode, globalSearch },
    }
    dispatch(searchFromDbSources(data))
    setActiveBreadItem(pages[1])
  }

  return (
    <div className={css.container}>
      <div className={css.wrapper}>
        <Show when={activeBreadItem !== pages[0]}>
          <Breadcrumbs
            items={pages}
            onItemClick={item => {
              setActiveBreadItem(item)
            }}
          />
        </Show>
      </div>
      <Switch>
        <Match when={activeBreadItem.label === pages.at(0)?.label}>
          <NewImportSourceSelector
            globalSearch={activeQuery.globalSearch}
            getFilesFromExplorer={getFilesFromExplorer}
            onDbSelect={onApplyGlobalSearch}
          />
        </Match>
        <Match when={activeBreadItem.label === pages.at(1)?.label && isCanImportFrom(selectedMode)}>
          <NewImportResults
            projectId={projectId}
            mode={selectedMode}
            globalSearch={globalSearch}
            activeQuery={activeQuery}
            addCrmsFiles={addCrmsFiles}
            addGeoDFiles={addGeoDFiles}
          />
        </Match>
      </Switch>
    </div>
  )
}
